import React, {useState, useContext, useEffect} from "react";
import SelectControl from '../SelecControl/SelectControl.jsx';

import procedimientoContext from "../../context/procedimientoContext/procedimientoContext.js";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBackspace } from "@fortawesome/free-solid-svg-icons";

import './ProcedimientosXactivoSubtabla.css';

import { createEstructuraProcedimiento, estructuraProcedimiento } from "../../utils/estructuras.js";


const ProcedimientosXactivoSubtabla = ({activoUniMed,activoType, procedimientosXactivo,handleChangeActivo, modo='Nuevo', tablaSeleccionada}) =>{

    const [indexToUpdate,setIndexToUpdate] = useState(-1);
    const [options,setOptions] = useState({procedimientos:[]});
    const [data,setData] = useState(''); //Data contiene la informacion de la tarea modificada.
    
    const procContext = useContext(procedimientoContext);
    const {procedimientoList} = procContext;

    const handleChange = (proc = {}, i, prop = '') => {
        let procsXactivo = procedimientosXactivo.slice();
        if(prop == 'lecturaCompletadoInicial'){
            procsXactivo[i][prop] = proc;
        }else if(procsXactivo[i]?.value == ''){
            procsXactivo[i] = proc;
            procsXactivo.push({...createEstructuraProcedimiento()});
        }else{
            procsXactivo[i] = proc;
        }
        handleChangeActivo({},'procedimientos',procsXactivo);                         
    }

    const handleDeleteProcedimiento = (proc, index) => {
        let actualProcedimientos = procedimientosXactivo.slice();
        if(proc.value != ''){
            let procedimientosToUpdate = actualProcedimientos.filter((p,i) => i != index);
            handleChangeActivo({},'procedimientos',procedimientosToUpdate);                         
        }
    }

    const handleRecuperarTipActivo = () =>{
        if(activoType != undefined){
            let procsToAdd = procedimientoList.filter(p => p.tipAct.includes(activoType.codTypeActivo));
            procsToAdd = procsToAdd.filter(p => !procedimientosXactivo.some(pA => pA.value == p.codProc));
            
            //Quita los elementos en vacio si es que su indice es distinto de 0.
            let procsToAddModelados = procedimientosXactivo.filter((p,i) => !(p.value == '' && i != 0)).slice();
            for(const p of procsToAdd){
                let procModelado = {
                    id:p._id,
                    label:p.name,
                    value:p.codProc
                }
                if(procsToAddModelados[0].value != '') procsToAddModelados.push(procModelado);
                else procsToAddModelados[0] = procModelado;
            }
            if(procsToAdd.length > 0){
                procsToAddModelados.push({...createEstructuraProcedimiento()});
                handleChangeActivo({},'procedimientos',procsToAddModelados);   
            }
        }
    }

    useEffect(()=>{
        if(procedimientoList != undefined && procedimientoList != null && procedimientoList.length > 0){
            let optionsP = procedimientoList.map((p) => {return {value:p.codProc,label:p.name,id:p._id,uniMed:p.uniMed.value}})
            setOptions({...options,procedimientos:optionsP});
        }else setOptions({...options,procedimientos:[]});
    },[procedimientoList])

    return <div className={`${(tablaSeleccionada != 'procedimientosXactivo') && 'inactive'} procedimientosXactivoSubtablaDiv`}>
        <div className="headerSubtabla">
            <label>Procedimientos por Activo</label> 
            <button disabled={modo == 'Vista'} onClick={()=>handleRecuperarTipActivo()}>Recuperar por Tipo de Activo</button>
        </div>
        <div className="procedimientosXactivoDiv">
            <div className={`${modo == 'Vista' ? 'twoColumns' : ''} subtablaHeader`}>
                {modo != 'Vista' && <label className="labeldelete"></label>}
                <label className="labelFecha">Procedimiento</label>
                <label className="labelEvento">Lectura Completado Inicial</label>
            </div>
            {   
                procedimientosXactivo.map((p,index) => <div className={`${modo == 'Vista' ? 'twoColumns' : ''} procedimientoXactivoDiv`} key={index}>
                {modo != 'Vista' && <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteProcedimiento(p,index)} />}
                    <SelectControl placeholder={"Seleccione una tarea..."} modo={modo} idSelect={"tarea"} handleChengeSelect={handleChange} optionsSelect={options.procedimientos} 
                    valueSeleccionada={p} tipo={'procedimientoXactivo'} selectSelect={handleChange} setData={setData} index={index} setNuevoEditado={'Ninguno'} setIndexToUpdate={setIndexToUpdate}/>
                    <input disabled={procedimientosXactivo[index].value == '' || modo == 'Vista' ? true : false} type={p.uniMed == 'DAYS' ? 'date' : 'number'} name="lecturaCompletadoInicial" value={p.lecturaCompletadoInicial} onChange={(e)=>handleChange(e.target.value,index,'lecturaCompletadoInicial')}/>
                </div>)
            }
        </div>
    </div>

}

export default React.memo(ProcedimientosXactivoSubtabla);